import React, { useState, useEffect, useContext, useRef } from 'react'

import { View, Text, useWindowDimensions, ScrollView, Platform, Dimensions } from 'react-native'

import {
  VFScreen,
  Icon,
  VFText,
  VFImageHeader,
  VFButton,
  QuickActionMenu
} from '@vfgroup-oneplatform/foundation/Components'

import Button from '../../Components/ButtonCard/index'
import OfferCard from '../../Components/OfferCard'
import ErrorHandlerComponent from '../../Components/ErrorHandler'


import styles from './CountryRoaming.Styles'
import RoamingContext from '../../Context'
import { getThemeImages } from '../../Themes/Modes/Helpers'
import { isArray } from 'lodash'
import ContentLoader, { Rect } from 'react-content-loader/native'

const LOADING_BUNDLES = [{}, {}, {}, {}]

const CountryRoaming = () => {
  const {
    onClose,
    theme,
    navigate,
    countriesList,
    selectedCountry: selectedCountryInfo,
    setScreen: screenStateChange,
    setSelectedCountry: countryChanger,
    searchType,
    // API CALLS
    getRoamingRecommendationOffer,
    getRoamingOfferBundles
  } = useContext(RoamingContext).roamingState

  const Images = getThemeImages(theme.name)

  const countries = countriesList?.countriesAlb || []

  countries?.forEach(item => {
    item.label = item.name
    item.value = item.name
    item.icon = Images[item.id] || Images.defaultFlag
  })

  const [bundles, setBundles] = useState(null)
  const [bundlesError, setBundlesError] = useState(false)
  const [bundlesLoading, setBundlesLoading] = useState(true)

  const [recommandation, setRecommandation] = useState(null)
  const [recommandationError, setRecommandationError] = useState(false)
  const [recommandationLoading, setRecommandationLoading] = useState(true)
  const [showRecommandationMoreInfo, setShowRecommandationMoreInfo] = useState(false)

  const [increaseHeight, setIncreaseHeight] = useState(false)

  const scrollRef = useRef()

  const { width } = useWindowDimensions()

  // const planDetails = {
  //   sms: 'Use you plan SMS for free ',
  //   min: 'Use you plan minutes for free',
  //   data: 'Use you plan Data up to 4.3GB for free'
  // }

  const getAndSetBundles = async () => {
    setBundlesLoading(true)
    try {
      const res = await getRoamingOfferBundles(selectedCountryInfo?.name || null)
      if (res) {
        setBundles(res)
        setBundlesError(false)
      } else {
        setBundlesError(true)
      }
    }
    catch (error) {
      setBundlesError(true)
    } finally {
      setBundlesLoading(false)
    }
  }

  const getAndSetRecommandation = async () => {
    setRecommandationLoading(true)
    try {
      const res = await getRoamingRecommendationOffer(selectedCountryInfo?.id || null)
      if (res) {
        setRecommandation(res)
        setRecommandationError(false)
      }
    } catch (error) {
      setRecommandationError(true)
    }
    finally {
      setRecommandationLoading(false)
    }
  }

  useEffect(() => {
    getAndSetRecommandation()
    getAndSetBundles()
    scrollRef?.current?.scrollTo({
      y: 0,
      animated: true
    })
  }, [selectedCountryInfo?.name])

  const [showSelect, setShowSelect] = useState(false)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        title={selectedCountryInfo?.name}
        onClose={onClose}
        withHeader={false}
        ref={scrollRef}
      >
        <VFImageHeader
          title={selectedCountryInfo?.name}
          onClose={onClose}
          image={{ uri: selectedCountryInfo?.image }}
          imageStyle={{ borderBottomWidth: 2, borderColor: 'grey' }}
          prefetch={{ url: selectedCountryInfo?.image }}
          withOverlay={false}
          titleStyle={styles.text}
          leftIcon={Images.backWhite}
          rightIcon={Images.closeWhite}
          showBack
          onBack={() => screenStateChange({ screen: 'HOME' })}
        />
        <ScrollView>
          <View style={[styles.container, { paddingHorizontal: '10%' }]}>
            <VFText
              i18nKey={`roaming_country_to`}
              placeHolders={[selectedCountryInfo?.name]}
              style={styles.boldText(theme)}
            />
            <VFText
              i18nKey={'roaming_country_to_description'}
              placeHolders={[selectedCountryInfo?.name]}
              style={styles.subText(theme)}
            />
            {/* More details button */}
            <VFButton
              type="secondary"
              title="roaming_learn_more"
              textStyle={styles.grayText(theme)}
              style={styles.button(theme)}
              onPress={() => {
                screenStateChange({
                  screen: 'COUNTRY_DETAILS',
                  props: {
                    headerImage: selectedCountryInfo?.image,
                    capital: selectedCountryInfo?.details.capital,
                    currency: selectedCountryInfo?.details.currency,
                    prefix: selectedCountryInfo?.details.prefix,
                    emergencyContacts:
                      selectedCountryInfo?.details.emergencyContacts,
                    embassiesOrConsulates:
                      selectedCountryInfo?.details.embassiesOrConsulates
                  }
                })
              }}
            />

            {/* Recommandation Offer Card */}
            <View style={styles.recommandationOffer}>
              {/* TODO: To be deleted later */}
              {/* {recommandationLoading && <ContentLoader
              width={width}
              height={80}
              backgroundColor={'#820000d3'}
              foregroundColor={'#E60000c3'}
              viewBox={`0 0 ${width} ${80}`}
            >
              <Rect x="0" y="0" rx="5" ry="5" width={width - 32} height={80} />
            </ContentLoader>} */}
              {recommandationError && !recommandationLoading && <ErrorHandlerComponent
                textButton={'roaming_get_recommandation_error'}
                onRetry={() => getAndSetRecommandation(selectedCountryInfo?.name || null)}
              />}
              {!recommandationError && <OfferCard
                title={recommandation?.title}
                description={recommandation?.description}
                image={selectedCountryInfo?.image}
                withButton={recommandation?.CTAType?.includes('deeplink')}
                buttonTitle={recommandation?.CTATitle}
                recommandationLoading={recommandationLoading}
                onPress={() => {
                  if (recommandation?.CTAType?.includes('webview')) {
                    navigate('WebView', { url: recommandation?.CTAUrl, title: recommandation?.title, isReact: true })
                  }
                  else if (recommandation?.CTAType?.includes('deeplink')) {
                    navigate('Catalogue', { bundleId: recommandation?.myOfferId })
                  }
                  else {
                    setShowRecommandationMoreInfo(true)
                  }
                }}
                theme={theme}
              />}
              <QuickActionMenu isVisible={showRecommandationMoreInfo} title={'roaming_more_info'} titleStyle={{ fontSize: 24, marginHorizontal: -15 }} withCloseButton type={'secondary'} closeModal={() => setShowRecommandationMoreInfo(false)} >
                <VFText i18nKey={recommandation?.longDesc} style={{ fontSize: 18, lineHeight: 24, marginVertical: 20 }} />
                <VFButton title='roaming_close' onPress={() => setShowRecommandationMoreInfo(false)} />
              </QuickActionMenu>
            </View>

            {/* Roaming Calcuator */}
            <View style={styles.calculatorContainer}>
              <View style={styles.displayFlex}>
                <Icon
                  source={Images.airplane}
                  size={28}
                  style={styles.calculatorIcon}
                />
                <VFText
                  i18nKey="roaming_country_calculator_title"
                  style={styles.calculatorTitle}
                />
              </View>
              <VFText
                i18nKey="roaming_country_calculator_description"
                style={styles.calculatorSubTitle}
              />

              <View
                onClick={() => setShowSelect(prev => !prev)}
                style={{
                  backgroundColor: theme.colors.cardBackgroundColorFour,
                  width: '100%',
                  // height: 64,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  borderRadius: 7,
                  borderColor: theme.colors.borderColorSeven,
                  padding: 10,
                  borderWidth: 1,
                  alignItems: 'center',
                  marginTop: 25,
                  cursor: 'pointer'
                }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Icon
                    name={Images[selectedCountryInfo.id]}
                    style={{ width: 32, height: 32, resizeMode: 'contain' }}
                  />
                  <VFText style={{ fontSize: 24, marginLeft: 16 }} i18nKey={selectedCountryInfo?.name} />
                </View>

                {/* <VFDropdown
                      items={countries}
                      containerStyle={styles.dropdownContainerStyle}
                      dropDownStyle={styles.dropdownStyle}
                      style={styles.dropdownStylesProp}
                      placeholderStyle={styles.dropdownPlaceholder(theme)}
                      defaultValue={selectedCountryInfo?.name}
                      autoScrollToDefaultValue={true}
                      isItemWithImage={true}
                      images={Images}
                      onValueChange={value => {
                        const country = countries.filter(
                          country => country.name === value
                        )
                        countryChanger(country[0])
                        setIncreaseHeight(false)
                      }}
                      rightIconColor={'red'}
                      zIndex={999}
                      onOpen={() => {
                        setIncreaseHeight(true)
                      }}
                      onClose={() => {
                        setIncreaseHeight(false)
                      }}
                    /> */}
                <Icon
                  name={showSelect ? Images.ic_chevron_down_red : Images.ic_chevron_up_red}
                  style={{ width: 32, height: 32, resizeMode: 'contain', tintColor: theme.colors.textColor }}
                />
              </View>
              {showSelect && <div style={{ height: 350, overflow: 'scroll', backgroundColor: theme.colors.cardBackgroundColorFour, padding: 20, marginTop: 16, borderRadius: 7, borderWidth: 1, borderColor: theme.colors.borderColorSeven, }}>
                {countries?.map(item => {
                  return (
                    <View>
                      <div
                        onClick={() => {
                          countryChanger(item)
                          setShowSelect(prev => !prev)
                        }}
                        style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', }}>
                        <Icon
                          name={Images[item.id]}
                          style={{ width: 32, height: 32, resizeMode: 'contain' }}
                        />
                        <VFText style={{ fontSize: 24, marginLeft: 16 }} i18nKey={item?.name} />
                      </div>
                      <div style={{ width: '100%', height: 1, backgroundColor: theme.colors.borderColorSeven, margin: '10px 0px', borderRadius: 7 }} />
                    </View>
                  )
                })}
              </div>
              }
              {selectedCountryInfo.postpaidNetworkOperator && (
                <VFText
                  i18nKey={'roaming_country_calculator_service_provider'}
                  placeHolders={[selectedCountryInfo?.postpaidNetworkOperator]}
                  style={styles.providerTitle}
                />
              )}
            </View>

            <View style={styles.bundleAndPricesContainer(theme)}>
              {/* <View style={styles.pricesContainer(theme)}>
              <Icon
                source={
                  !bundles && !recommandation ? Images.warning : Images.success
                }
                size={28}
                style={styles.calculatorIcon}
              />
              <View style={styles.calculatorIcon}>
                <VFText
                  style={styles.bundleAvailability(theme)}
                  i18nKey={
                    bundles && recommandation
                      ? `roaming_calculator_yes_bundle`
                      : `roaming_calculator_no_bundle`
                  }
                  placeHolders={[selectedCountryInfo.name]}
                />
              </View>
            </View> */}

              {
                // Check for userType to be postpaid or prepaid and get the right tariffs
                selectedCountryInfo?.tariffs[searchType].map(item => {
                  if (!item.title || !item.price) {
                    return <></>
                  }
                  return (
                    <View style={styles.pricesContainer(theme)}>
                      <VFText
                        style={styles.priceTitle(theme)}
                        i18nKey={item?.title}
                      />
                      <VFText
                        style={styles.priceValue(theme)}
                        i18nKey={item?.price.toString() + ' Lekë'}
                      />
                    </View>
                  )
                })
              }
            </View>

            {/* Roaming Bundles */}
            <View style={styles.bundleContainer}>
              {bundles?.length > 0 && (
                <VFText
                  i18nKey="roaming_bundles_button_title"
                  style={styles.boldText(theme)}
                />
              )}
              {bundlesError && (
                <ErrorHandlerComponent
                  textButton={'roaming_bundles_default_error'}
                  onRetry={() => getAndSetBundles(selectedCountryInfo?.name)}
                />
              )}
              {bundles?.length > 0 && (
                <VFText
                  i18nKey="roaming_country_offers_subtitle"
                  style={styles.subText(theme)}
                />
              )}
              {bundlesLoading && <View style={{ marginTop: 20 }}>
                {LOADING_BUNDLES.map(() => <Button bundlesLoading={true} />)}
              </View>}
              {isArray(bundles) && !bundlesLoading &&
                bundles?.map(bundle => {
                  return (
                    <Button
                      title={bundle.title}
                      price={bundle.price}
                      icon={Images.airplane}
                      directionIcon={Images.rightArrowRed}
                      onPress={() =>
                        navigate('Catalogue', {
                          bundleCategory: 'roaming',
                          bundleId: bundle.id
                        })
                      }
                      theme={theme}
                      bundlesLoading={false}
                    />
                  )
                })}
            </View>
          </View>
        </ScrollView>

      </VFScreen>
    )
  }

  return (
    <VFScreen
      title={selectedCountryInfo?.name}
      onClose={onClose}
      withHeader={false}
      ref={scrollRef}
    >
      <VFImageHeader
        title={selectedCountryInfo?.name}
        onClose={onClose}
        image={{ uri: selectedCountryInfo?.image }}
        imageStyle={{ borderBottomWidth: 2, borderColor: 'grey' }}
        prefetch={{ url: selectedCountryInfo?.image }}
        withOverlay={false}
        titleStyle={styles.text}
        leftIcon={Images.backWhite}
        rightIcon={Images.closeWhite}
        showBack
        onBack={() => screenStateChange({ screen: 'HOME' })}
      />
      <ScrollView>

        <View style={styles.container}>
          <VFText
            i18nKey={`roaming_country_to`}
            placeHolders={[selectedCountryInfo?.name]}
            style={styles.boldText(theme)}
          />
          <VFText
            i18nKey={'roaming_country_to_description'}
            placeHolders={[selectedCountryInfo?.name]}
            style={styles.subText(theme)}
          />
          {/* More details button */}
          <VFButton
            type="secondary"
            title="roaming_learn_more"
            textStyle={styles.grayText(theme)}
            style={styles.button(theme)}
            onPress={() => {
              screenStateChange({
                screen: 'COUNTRY_DETAILS',
                props: {
                  headerImage: selectedCountryInfo?.image,
                  capital: selectedCountryInfo?.details.capital,
                  currency: selectedCountryInfo?.details.currency,
                  prefix: selectedCountryInfo?.details.prefix,
                  emergencyContacts:
                    selectedCountryInfo?.details.emergencyContacts,
                  embassiesOrConsulates:
                    selectedCountryInfo?.details.embassiesOrConsulates
                }
              })
            }}
          />

          {/* Recommandation Offer Card */}
          <View style={styles.recommandationOffer}>
            {/* TODO: To be deleted later */}
            {/* {recommandationLoading && <ContentLoader
            width={width}
            height={80}
            backgroundColor={'#820000d3'}
            foregroundColor={'#E60000c3'}
            viewBox={`0 0 ${width} ${80}`}
          >
            <Rect x="0" y="0" rx="5" ry="5" width={width - 32} height={80} />
          </ContentLoader>} */}
            {recommandationError && !recommandationLoading && <ErrorHandlerComponent
              textButton={'roaming_get_recommandation_error'}
              onRetry={() => getAndSetRecommandation(selectedCountryInfo?.name || null)}
            />}
            {!recommandationError && <OfferCard
              title={recommandation?.title}
              description={recommandation?.description}
              image={selectedCountryInfo?.image}
              withButton={recommandation?.CTAType?.includes('deeplink')}
              buttonTitle={recommandation?.CTATitle}
              recommandationLoading={recommandationLoading}
              onPress={() => {
                if (recommandation?.CTAType?.includes('webview')) {
                  navigate('WebView', { url: recommandation?.CTAUrl, title: recommandation?.title, isReact: true })
                }
                else if (recommandation?.CTAType?.includes('deeplink')) {
                  navigate('Catalogue', { bundleId: recommandation?.myOfferId })
                }
                else {
                  setShowRecommandationMoreInfo(true)
                }
              }}
              theme={theme}
            />}
            <QuickActionMenu isVisible={showRecommandationMoreInfo} title={'roaming_more_info'} titleStyle={{ fontSize: 24, marginHorizontal: -15 }} withCloseButton type={'secondary'} closeModal={() => setShowRecommandationMoreInfo(false)} >
              <VFText i18nKey={recommandation?.longDesc} style={{ fontSize: 18, lineHeight: 24, marginVertical: 20 }} />
              <VFButton title='roaming_close' onPress={() => setShowRecommandationMoreInfo(false)} />
            </QuickActionMenu>
          </View>

          {/* Roaming Calcuator */}
          <View style={styles.calculatorContainer}>
            <View style={styles.displayFlex}>
              <Icon
                source={Images.airplane}
                size={28}
                style={styles.calculatorIcon}
              />
              <VFText
                i18nKey="roaming_country_calculator_title"
                style={styles.calculatorTitle}
              />
            </View>
            <VFText
              i18nKey="roaming_country_calculator_description"
              style={styles.calculatorSubTitle}
            />

            <View
              onClick={() => setShowSelect(prev => !prev)}
              style={{
                backgroundColor: theme.colors.cardBackgroundColorFour,
                width: '100%',
                // height: 64,
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderRadius: 7,
                borderColor: theme.colors.borderColorSeven,
                padding: 10,
                borderWidth: 1,
                alignItems: 'center',
                marginTop: 25,
                cursor: 'pointer'
              }}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Icon
                  name={Images[selectedCountryInfo.id]}
                  style={{ width: 32, height: 32, resizeMode: 'contain' }}
                />
                <VFText style={{ fontSize: 24, marginLeft: 16 }} i18nKey={selectedCountryInfo?.name} />
              </View>

              {/* <VFDropdown
                      items={countries}
                      containerStyle={styles.dropdownContainerStyle}
                      dropDownStyle={styles.dropdownStyle}
                      style={styles.dropdownStylesProp}
                      placeholderStyle={styles.dropdownPlaceholder(theme)}
                      defaultValue={selectedCountryInfo?.name}
                      autoScrollToDefaultValue={true}
                      isItemWithImage={true}
                      images={Images}
                      onValueChange={value => {
                        const country = countries.filter(
                          country => country.name === value
                        )
                        countryChanger(country[0])
                        setIncreaseHeight(false)
                      }}
                      rightIconColor={'red'}
                      zIndex={999}
                      onOpen={() => {
                        setIncreaseHeight(true)
                      }}
                      onClose={() => {
                        setIncreaseHeight(false)
                      }}
                    /> */}
              <Icon
                name={showSelect ? Images.ic_chevron_down_red : Images.ic_chevron_up_red}
                style={{ width: 32, height: 32, resizeMode: 'contain', tintColor: theme.colors.textColor }}
              />
            </View>
            {showSelect && <div style={{ height: 150, overflow: 'scroll', backgroundColor: theme.colors.cardBackgroundColorFour, padding: 20, marginTop: 16, borderRadius: 7, borderWidth: 1, borderColor: theme.colors.borderColorSeven, }}>
              {countries?.map(item => {
                return (
                  <View>
                    <div
                      onClick={() => {
                        countryChanger(item)
                        setShowSelect(prev => !prev)
                      }}
                      style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', }}>
                      <Icon
                        name={Images[item.id]}
                        style={{ width: 32, height: 32, resizeMode: 'contain' }}
                      />
                      <VFText style={{ fontSize: 24, marginLeft: 16 }} i18nKey={item?.name} />
                    </div>
                    <div style={{ width: '100%', height: 1, backgroundColor: theme.colors.borderColorSeven, margin: '10px 0px', borderRadius: 7 }} />
                  </View>
                )
              })}
            </div>
            }
            {selectedCountryInfo.postpaidNetworkOperator && (
              <VFText
                i18nKey={'roaming_country_calculator_service_provider'}
                placeHolders={[selectedCountryInfo?.postpaidNetworkOperator]}
                style={styles.providerTitle}
              />
            )}
          </View>

          <View style={styles.bundleAndPricesContainer(theme)}>
            {/* <View style={styles.pricesContainer(theme)}>
            <Icon
              source={
                !bundles && !recommandation ? Images.warning : Images.success
              }
              size={28}
              style={styles.calculatorIcon}
            />
            <View style={styles.calculatorIcon}>
              <VFText
                style={styles.bundleAvailability(theme)}
                i18nKey={
                  bundles && recommandation
                    ? `roaming_calculator_yes_bundle`
                    : `roaming_calculator_no_bundle`
                }
                placeHolders={[selectedCountryInfo.name]}
              />
            </View>
          </View> */}

            {
              // Check for userType to be postpaid or prepaid and get the right tariffs
              selectedCountryInfo?.tariffs[searchType].map(item => {
                if (!item.title || !item.price) {
                  return <></>
                }
                return (
                  <View style={styles.pricesContainer(theme)}>
                    <VFText
                      style={styles.priceTitle(theme)}
                      i18nKey={item?.title}
                    />
                    <VFText
                      style={styles.priceValue(theme)}
                      i18nKey={item?.price.toString() + ' Lekë'}
                    />
                  </View>
                )
              })
            }
          </View>

          {/* Roaming Bundles */}
          <View style={styles.bundleContainer}>
            {bundles?.length > 0 && (
              <VFText
                i18nKey="roaming_bundles_button_title"
                style={styles.boldText(theme)}
              />
            )}
            {bundlesError && (
              <ErrorHandlerComponent
                textButton={'roaming_bundles_default_error'}
                onRetry={() => getAndSetBundles(selectedCountryInfo?.name)}
              />
            )}
            {bundles?.length > 0 && (
              <VFText
                i18nKey="roaming_country_offers_subtitle"
                style={styles.subText(theme)}
              />
            )}
            {bundlesLoading && <View style={{ marginTop: 20 }}>
              {LOADING_BUNDLES.map(() => <Button bundlesLoading={true} />)}
            </View>}
            {isArray(bundles) && !bundlesLoading &&
              bundles?.map(bundle => {
                return (
                  <Button
                    title={bundle.title}
                    price={bundle.price}
                    icon={Images.airplane}
                    directionIcon={Images.rightArrowRed}
                    onPress={() =>
                      navigate('Catalogue', {
                        bundleCategory: 'roaming',
                        bundleId: bundle.id
                      })
                    }
                    theme={theme}
                    bundlesLoading={false}
                  />
                )
              })}
          </View>
        </View>
      </ScrollView>

    </VFScreen>
  )
}

CountryRoaming.defaultProps = {}

export default CountryRoaming
